import { TFunction } from 'i18next';
import { getOilChunk, isCertasOil } from 'components/StockInfo/catalogStockUtils';
import { textFormatter } from 'utils';

export type ButtonSize = 'small' | 'middle' | 'large';
export const PRICE_WRAPPER_MAX_WIDTH = 200;

export const getVatExcludedText = (t: TFunction, price: number, currency?: string, multipleOffers = false) => {
  const priceText = t('common.price.vat_exclude_price', '{{vat_exclude_price}} VAT. Excl', {
    vat_exclude_price: textFormatter.formatCurrency(price, currency ?? ''),
  });
  return multipleOffers
    ? t('common.price.from_price', 'from {{price}}', {
        price: priceText,
      })
    : priceText;
};

export const getDiscountText = (t: TFunction, discountRate?: string) => {
  const formattedDiscount = textFormatter.formatPercentDecimal(Number(discountRate) || 0);
  return t('common.discount.including_discount', 'Including {{discount_in_percentage}} discount', {
    discount_in_percentage: formattedDiscount,
  });
};

export const getDiscountedPrice = (price: number, discount?: number): number => {
  if (discount === undefined || discount === 0) {
    return price;
  }
  return price * (1 - discount / 100);
};

export const getChunkSize = (
  chunkReferences: any[] | undefined,
  referenceNumber: string,
  isOilUser: boolean,
  stock: any,
  fallbackChunk?: string,
): number => {
  const chunkRef = chunkReferences?.find((ref) => ref.referenceNumber === referenceNumber);
  if (
    !isCertasOil(chunkRef?.familyCode, chunkRef?.productModelCode) &&
    stock?.data?.warehouses?.some((wh: any) => wh.type === 'LOCAL' && wh.confirmedQuantity > 0)
  ) {
    return 1;
  }
  return isOilUser && isCertasOil(chunkRef?.familyCode, chunkRef?.productModelCode)
    ? getOilChunk(chunkRef, fallbackChunk)
    : 1;
};
